import {notify} from 'react-notify-toast';

let Notification = {}

let queue = notify.createShowQueue();

Notification.show = (message, type, duration = 2000, color = {}) => {

  if (type === 'info') {
    color = { background: '#4d8fc1', text: 'white' };
    type = 'custom';
  }

  if (type === 'custom')
    queue(message, type, duration, color);
  else 
    queue(message, type, duration);
};

module.exports = Notification;


// WEBPACK FOOTER //
// ./src/js/services/Notification.js